<template>
  <button :disabled="isDisabled" :class="classes" @click.prevent="page.click">
    <slot>{{ page.number }}</slot>
  </button>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-pagination-button :page="page">
   *   {{ page.number }}
   * </ak-pagination-button>
   */
  name: 'AkPaginationButton',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Object}
     * @description This is the config for the pagination button this
     * will contain the page number and click action ect.
     */
    page: {
      type: Object,
      required: true,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing
   * all of the attributes for the component to use.
   */
  setup(props) {
    /**
     * @returns {Boolean}
     * @description Returns the disabled state for the pagination
     * button.
     */
    const isDisabled = computed(() => {
      return props.page.disabled
    })

    /**
     * @returns {Array}
     * @description Returns the classes for the root of the component
     */
    const classes = computed(() => {
      return {
        'is-active': props.page.isCurrent,
        'is-disabled': isDisabled.value,
        [props.page.class]: true,
      }
    })

    return {
      isDisabled,
      classes,
    }
  },
})
</script>
